/**
 * Constraints on an image uploaded from the Unlayer editor. They mirror OPINK's
 * `UploadFileCommandValidator` (`FileUpload:MaxFileSizeBytes`, `AllowedContentTypes`), which stays the
 * authority: checking here only keeps a file OPINK would refuse off the network.
 */
/** Used when the runtime config sets no `editorImageMaxBytes`; matches OPINK's default cap. */
export const DEFAULT_EDITOR_IMAGE_MAX_BYTES = 500 * 1024;
export const EDITOR_IMAGE_CONTENT_TYPES = ["image/png", "image/jpeg"];
export function checkEditorImage(file, maxBytes) {
    if (!EDITOR_IMAGE_CONTENT_TYPES.includes(file.type))
        return "invalidType";
    if (file.size > maxBytes)
        return "tooLarge";
    return null;
}
